import instance from "@/services/api";

export const changeWarrantyStatusAPI = {
  async getList(client_request_id, grt_request_id) {
    return await instance().get(`/client_request/${client_request_id}/grt_requests/${grt_request_id}/status_chronology/read/`).then(res => res?.data)
  },
  async getStatuses() {
    return await instance().get(`/common/grt_statuses/read/`).then(res => res?.data)
  }
}